import { createReducer, on } from '@ngrx/store'
import { IAppState } from '@adex/shared/models/states/app.state'
import { unauthorizedUser } from '@adex/store/actions/global.actions'


const initialState: IAppState = {}

export const appReducer = createReducer(
  initialState,
  on(unauthorizedUser, () => ({ ...initialState }))
)
